var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotwear5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.386 21.01L51.4773 29.3954L47.7319 31.8049L44.1177 24.6003L46.718 21.01H47.386Z",
    fill: "#AE2100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4889 21.01L60.1727 24.6958L57.143 31.8049L53.4453 28.799L56.8209 21.01H57.4889Z",
    fill: "#AE2100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4455 33.1408L58.1571 35.8365L62.6539 25.6858L72.8405 27.9044L82.7885 55.3388L81.1543 81.9264L72.4111 81.5447L73.6158 57.0923C72.256 53.4781 70.2998 50.0905 68.4748 46.703C67.9977 45.8084 68.8207 44.878 66.9122 45.2597L68.8207 76.4753C65.5167 79.6362 59.4214 82.7494 54.8172 82.7137C54.03 82.7137 53.9346 82.6659 53.4336 81.9741V33.1408H53.4455Z",
    fill: "#AE2100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7499 83C45.1079 81.8907 39.1439 80.6383 35.4104 75.8432L37.2593 45.2717L31.2476 56.4244L31.7843 81.5567L23.1127 82.3321L21.3115 56.4721L32.1541 27.6898L41.5295 25.8052L46.7063 35.8247L50.7379 33.129V82.9881L50.7499 83Z",
    fill: "#AE2100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotwear5);
export default __webpack_public_path__ + "static/media/notwear5.1a2667b5e67b4fc273338ce25a58166e.svg";
export { ForwardRef as ReactComponent };